import z from "zod";

export const updateTargetListSchema = z.object({
    name: z.string()
        .min(1, "Il nome della lista target è obbligatorio")
        .max(255, "Il nome non può superare i 255 caratteri")
        .trim(),

    commercialIds: z.array(z.string())
        .min(1, "Almeno un commerciale deve essere selezionato")
        .refine((ids) => ids.every(id => id.trim().length > 0), {
            message: "Tutti i commerciali selezionati devono essere validi"
        }),

    revenue: z.string()
        .regex(/^(undefined|=|<|>|><):(undefined|\d+(?:\.\d+)?):(undefined|\d+(?:\.\d+)?)$/, {
            message: "Formato del fatturato non valido"
        })
        .refine((value) => {
            const parts = value.split(":");
            const sign = parts[0];
            const first = parts[1];
            const second = parts[2];

            if (sign !== "undefined" && first === "undefined") {
                return false;
            }

            if (sign === "><" && second === "undefined") {
                return false;
            }

            return true;
        }, {
            message: "Il fatturato deve avere valori validi per il tipo di comparazione selezionato"
        }),

    employeesNumber: z.string()
        .regex(/^(undefined|=|<|>|><):(undefined|\d+):(undefined|\d+)$/, {
            message: "Formato del numero dipendenti non valido"
        })
        .refine((value) => {
            const parts = value.split(":");
            const sign = parts[0];
            const first = parts[1];
            const second = parts[2];

            if (sign !== "undefined" && first === "undefined") {
                return false;
            }

            if (sign === "><" && second === "undefined") {
                return false;
            }

            return true;
        }, {
            message: "Il numero dipendenti deve avere valori validi per il tipo di comparazione selezionato"
        }),

    departments: z.array(z.string().trim())
        .refine((deps) => deps.every(d => d.length > 0), {
            message: "Tutti i reparti selezionati devono essere validi"
        }),

    roles: z.array(z.string().trim())
        .refine((roles) => roles.every(r => r.length > 0), {
            message: "Tutti i ruoli selezionati devono essere validi"
        }),

    sectors: z.array(z.string().trim())
        .refine((sectors) => sectors.every(s => s.length > 0), {
            message: "Tutti i settori selezionati devono essere validi"
        }),

    categories: z.array(z.string().trim())
        .refine((categories) => categories.every(c => c.length > 0), {
            message: "Tutte le categorie selezionate devono essere valide"
        }),
})

export type UpdateTargetListFormValues = z.infer<typeof updateTargetListSchema>;

export const newTargetListSchema = updateTargetListSchema.extend({
    projectId: z.string()
});

export type NewTargetListFormValues = z.infer<typeof newTargetListSchema>;